import React from "react"
import { useSelector } from "react-redux"

import {
    PROVEN_NO, PROVEN_IN_USE, PRIOR_USE,
    LOW_DEMAND_MODE, HIGH_DEMAND_MODE, CONTINUOUS_MODE,
} from "const"
import {
    StoreType,
    SilDeviceType,
    SilDeviceNestedType,
} from "client/store"
import { TableColumn } from "client/components"

import FormatScientific from "client/pages/sil/format/scientific"

const Columns = () => {
    const lang = useSelector((state: StoreType) => state.system.lang)

    // no need to set cell width for inverted table
    const columns: TableColumn[] = [
        {
            field: "name",
            header: lang.name,
        },
        {
            field: "type",
            header: lang.type,
        },
        {
            field: "mode",
            header: lang.mode,
            formatter: (device: SilDeviceType | SilDeviceNestedType) => {
                const subsystem = device as SilDeviceType
                const nested = device as SilDeviceNestedType

                if (nested.mode) {
                    if (nested.mode === LOW_DEMAND_MODE) return lang.modeLowDemand
                    if (nested.mode === HIGH_DEMAND_MODE) return lang.modeHighDemand
                    if (nested.mode === CONTINUOUS_MODE) return lang.modeContinuous
                } else {
                    // subsystem can have only single mode
                    if (subsystem.lowDemandMode) return lang.modeLowDemand
                    if (subsystem.highDemandMode) return lang.modeHighDemand
                    if (subsystem.continuousMode) return lang.modeContinuous

                    // no mode selected
                    if (
                        !subsystem.lowDemandMode
                        && !subsystem.highDemandMode
                        && !subsystem.continuousMode
                    ) return lang.modesNotTheSame
                }
                return null
            },
        },
        {
            field: "logicSolver",
            header: lang.logicSolver,
            sortable: true,
            formatter: (device: SilDeviceType | SilDeviceNestedType) => {
                if (device.logicSolver === true) return lang.yes
                if (device.logicSolver === false) return lang.no
                return lang.notAllDevicesLogicSolvers
            },
        },
        {
            field: "provenInUse",
            header: lang.provenReliabilityData,
            sortable: true,
            formatter: (device: SilDeviceType | SilDeviceNestedType) => {
                if (device.provenInUse === PROVEN_NO) return lang.no
                if (device.provenInUse === PROVEN_IN_USE) return lang.provenInUse
                if (device.provenInUse === PRIOR_USE) return lang.priorUse
                return lang.notAllDevicesProvenInUse
            },
        },
        {
            field: "sd",
            header: "SD",
            formatter: (device: SilDeviceType | SilDeviceNestedType) => <FormatScientific data={device.sd} tableView />,
        },
        {
            field: "su",
            header: "SU",
            formatter: (device: SilDeviceType | SilDeviceNestedType) => <FormatScientific data={device.su} tableView />,
        },
        {
            field: "dd",
            header: "DD",
            formatter: (device: SilDeviceType | SilDeviceNestedType) => <FormatScientific data={device.dd} tableView />,
        },
        {
            field: "du",
            header: "DU",
            formatter: (device: SilDeviceType | SilDeviceNestedType) => <FormatScientific data={device.du} tableView />,
        },
    ]

    return columns
}
export default Columns
